import { Box, Container } from "@mui/material";
import React,{useState,useEffect} from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import { PickPairsStock } from "../../CommonPage/PickPair/PickPairsStock";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import NewCommonity from "../../Componenets/Globalassets/NewCommonity";
import { NewMetalsPairs } from "../../CommonPage/PickPair/NewMetalsPairs";
import { useLanguage } from "../../context/LanguageContext";
import { market } from "../../CommonPage/MarketFlow/TradeData";
import GlobeMarket from "../../Componenets/Globalassets/GlobeMarket";

export const Metals = () => {

  const { language, translations } = useLanguage();

  const cardData = [
    {
      heading:translations[language]?.alternativeAssetsCardData?.title,
      logo: "/Images/metall1.png",
      description:translations[language]?.alternativeAssetsCardData?.description,
    },
    {
      heading:translations[language]?.alternativeAssetsCardData?.title1,
      logo: "/Images/metall2.png",
      description:translations[language]?.alternativeAssetsCardData?.description2,
    },
    {
      heading:translations[language]?.alternativeAssetsCardData?.title2,
      logo: "/Images/metall3.png",
      description:translations[language]?.alternativeAssetsCardData?.description2,
    },
    {
      heading:translations[language]?.alternativeAssetsCardData?.title3,
      logo: "/Images/metall4.png",
      description:translations[language]?.alternativeAssetsCardData?.description3,
    },
  ];



  const Commonity = [
    {
      name: "COFFEE",
      spread: "1.2",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.4",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.1",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.2",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.4",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.1",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "COFFEE",
      spread: "1.2",
      img: "/Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
  ];




  return (
    <Box>
      <Trading
      banner="https://res.cloudinary.com/dk24unkwu/image/upload/v1753695154/forexClean4_e2ydek.png"
        titleLine1={translations[language]?.metalsTrading?.titleLine1}
        active={translations[language]?.metalsTrading?.active}
        titleLine2={translations[language]?.metalsTrading?.titleLine2}
        subtitle={translations[language]?.metalsTrading?.subtitle}
      />
      <GlobeMarket  />
      <WhyTradeForex
        subtitle={translations[language]?.Tradesf}
        cardData={cardData}
      />
      <NewMetalsPairs />
      {/* <PickPairsStock Commonity={Commonity} title="Pick Your Commodities" subtitle="You can see all trading hours in the Members Area." /> */}
      <Container maxWidth="xl">

      <Box mt={10} mx={7}>
        <NewCommonity
          title={
            <>
             {translations[language]?.Metalsbotom} <br />
              BBCorp?
            </>
          }
          subtitle={
            <>
            {translations[language]?.Metalsbotom1} <br /> {translations[language]?.Metalsbotom2}
            </>
          }
        />
      </Box>
      </Container>
    </Box>
  );
};
//
